import React, { useContext, useEffect } from "react";
import QrScanIcon from "../../icons/QrCode";
import styles from './ScanToStart.module.scss'
import { useTranslation } from "../../hooks/useTranslation";
import ViewTicketDetailPageContext, { IViewTicketDetailPageContext } from "../../Contexts/ViewTicketPageContext/ViewTicketPageContext";

const ScanToStart: React.FC = () => {
    const { t } = useTranslation();

    const {
        setShowScanToStart,
    } = useContext(ViewTicketDetailPageContext) as IViewTicketDetailPageContext;

    useEffect(() => {
        setShowScanToStart(false);
        localStorage.setItem('scanQRRequired', 'true');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.iconWrapper}>
                    <QrScanIcon />
                </div>
                <h1 className={styles.heading}>{t('pages:scanToStart:heading')}</h1>
                <p className={styles.subtitle}>
                    {t('pages:scanToStart:subTitle')}
                </p>
            </div>
            <p className={styles.footer}>
                {t('pages:scanToStart:footer:text')}
            </p>
        </div>
    );
}

export default ScanToStart
